import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState('reviewOptionTypes', [
      'reviewOptionTypes',
      'isLoadingReviewOptionTypes'
    ])
  },
  created() {
    if (this.loadableReviewOptionTypes) this.fetchReviewOptionTypes();
  },
  methods: {
    ...mapActions('reviewOptionTypes', ['fetchReviewOptionTypes'])
  }
};
